angular.module('lf.desktop')

.controller('AppCtrl', function ($scope, $rootScope, $timeout, $log, cartService, wishlistService, helpers, popupsService, popoversService, preloadData, siteService) {
  $timeout(function() {
    _.each(preloadData.postNgFunctions, function(fn) {
          try { 
            fn();
          } catch (e) {
            $log.warn('Error in postNgFunctions: ' + e);
          }
        });
    }, 0);
  
  $rootScope.helpers = helpers;
  
  $rootScope.shop = preloadData.shop;
    
  $rootScope.popups = popupsService;
  
  $rootScope.$on('shopDataUpdate:external', function (e, shop) {
    $rootScope.$apply(function() {
      $rootScope.shop = shop;
      $rootScope.$broadcast(shop.eventType, {type: siteService.getSiteData(shop.shoppingActionSiteId).siteProductType});
    });
  });
  
  $rootScope.getHardgoodsCartItemsCount = cartService.getHardgoodsCartItemsCount;
  
  $rootScope.getSoftgoodsCartItemsCount = cartService.getSoftgoodsCartItemsCount;
  
  $rootScope.getWishlistItemsCount = wishlistService.getItemsCount;

  $rootScope.getHardgoodsWishlistItems = function (limit) {
    return wishlistService.getHardgoods().slice(-limit || 0);
  }
  
  $rootScope.getSoftgoodsWishlistItems = function (limit) {
    return wishlistService.getSoftgoods().slice(-limit || 0);
  }
  
  $rootScope.$on('cart:add', function (event, product) {
    var name = 'mini-cart-' + product.type;
    popoversService.show(name, {hideDelay: 5000});
  });
  
  $rootScope.$on('wishlist:add', function () {
    popoversService.show('mini-wishlist', {hideDelay: 5000});
  });
  
});
